import type { ReactNode } from 'react'
import { Icon } from '@/ui'
import styles from './CenteredScreen.module.css'

/** Full-page brand layout for login, context picker and "no access" screens. */
export function CenteredScreen({ children, width = 440 }: { children: ReactNode; width?: number }) {
  return (
    <div className={styles.page}>
      <div className={styles.brand}>
        <div className={styles.tile}>
          <Icon name="apartment" size={19} />
        </div>
        <span className={styles.name}>Condi</span>
      </div>
      <div className={styles.card} style={{ maxWidth: width }}>
        {children}
      </div>
    </div>
  )
}
